import ArticleLayout from '@/pages/article/components/ArticleLayout';
import { allArticles } from '@/mocks/articles';

export default function SugargooWarehouseGuidePage() {
  const article = allArticles.find(a => a.slug === 'sugargoo-warehouse-guide')!;
  return <ArticleLayout article={article} />;
}